import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Aboutus from './components/Aboutus';
import Donators from './components/Donators';
import Masajids from './components/Masajids';
import OurBlogs from './components/OurBlogs';
import Header from './components/Header';
import Footer from './components/Footer';
import OTPForm from './components/OTPForm';
import OtpVerification from './components/OtpVerification';
import VideoForm from './components/VideoForm';
import VideoGallery from './components/VideoGallery';
import { useEffect, useState } from 'react';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import AdminRegister from './components/AdminRegister';
import Carousel from './components/Carousel';
import AddCause from './components/AddCause';
import CauseList from './components/CauseList';
import DeleteCause from './components/DeleteCause';
import CauseDetails from './components/CauseDetails';
import Districtcommitie from './components/Districtcommitie';
import OfficeBearers from './components/OfficeBearers';
import AddOfficeBearer from './components/BackendUploades/AddOfficeBearer';
import DistrictCommitteeAddForm from './components/BackendUploades/DistrictCommitteeAddForm ';
import DistrictCommitteeManage from './components/BackendUploades/DistrictCommitteeManage';
import MasjidForm from './components/BackendUploades/MasjidForm';
import PdfLibrary from './components/PdfLibrary ';
import EventFormAndList from './components/BackendUploades/EventFormAndList';
import EventsList from './components/BackendUploades/EventsList';
import ManageEvents from './components/BackendUploades/ManageEvents';
import ContactUs from './components/ContactUs';
import ScrollToTop from './components/ScrollToTop';
import NotFound from './components/NotFound';
import Policies from './components/Policies';
import DonationQRCodePage from './components/DonationQRCodePage';
import Brochures from './components/Brochures';

function App() {

  return (
    <div>
      <BrowserRouter>
      <ScrollToTop />
        <AppContent />
      </BrowserRouter>
    </div>
  );
}


function AppContent() {
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const location = useLocation(); // Now inside the BrowserRouter
  const navigate = useNavigate();  // Now inside the BrowserRouter

  const checkAuth = async () => {
    const token = localStorage.getItem("usertoken");

    if (!token) {
      setAdminLoggedIn(false);
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_REQUESTING_API}/validation`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      if (res.ok) {
        setAdminLoggedIn(true);
        if (location.pathname === "/adminlogin") {
          navigate("/admin/dashboard");
        }
      } else {
        setAdminLoggedIn(false);
        if (location.pathname.startsWith("/admin")) {
          navigate("/adminlogin");
        }
      }
    } catch (error) {
      console.error("Error during validation", error);
      setAdminLoggedIn(false);
      if (location.pathname.startsWith("/admin")) {
        navigate("/adminlogin");
      }
    }
  };

  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

    // Check if the current route is CauseDetails
    const isCauseDetailsRoute = location.pathname.startsWith('/cause/');
  return (
    <>
      {/* Only show the header if the route does not start with /admin or /cause */}
{!location.pathname.startsWith("/admin") && !location.pathname.startsWith("/cause/") && <Header />}

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/officebearers" element={<OfficeBearers />} />
        <Route path="/commitee" element={<Districtcommitie />} />
        <Route path="/masajids" element={<Masajids />} />
        <Route path="/donators" element={<Donators />} />
        <Route path="/donate" element={<DonationQRCodePage />} />
        <Route path="/ourcause" element={<CauseList />} />
        <Route path="/addcause" element={<AddCause />} />
        <Route path="/addmasjid" element={<MasjidForm />} />
        <Route path="/library" element={<PdfLibrary />} />
        <Route path="/brochures" element={<Brochures />} />
        <Route path="/events" element={<EventFormAndList />} />
        <Route path="/eventslist" element={<EventsList />} />
        <Route path="/manageevents" element={<ManageEvents />} />
        <Route path="/contactus" element={<ContactUs />} />
<Route path="/policies" element={<Policies />} />
{/* working 20/jun/2025 */}
        {/* <Route path="/donationpay" element={<DonateRecurring />} /> */}

        
        <Route path="/addofficebearers" element={<AddOfficeBearer />}/>
        <Route path="/addcommiteemembers" element={<DistrictCommitteeAddForm />}/>
        <Route path="/updatedelcommiteemembers" element={<DistrictCommitteeManage />}/>
        
        <Route path="/cause/:id" element={<CauseDetails />} />
        <Route path="/delete" element={<DeleteCause />} />

        <Route path="/otp" element={<OTPForm />} />
        <Route path="/otp1" element={<OtpVerification />} />
        <Route path="/postvideo" element={<VideoForm />} />
        <Route path="/getvideo" element={<VideoGallery />} />
        <Route path="/blogs" element={<OurBlogs />} />
        <Route path="/" element={<Carousel />} />



  {/* 404 catch-all route */}
  <Route path="*" element={<NotFound />} />

        Admin routes
        <Route path="/admin/dashboard/*" element={adminLoggedIn ? <AdminDashboard /> : <Navigate to="/adminlogin" />} />
        <Route path="/adminlogin" element={<AdminLogin setAdminLoggedIn={setAdminLoggedIn} />} />
        <Route path="/register" element={<AdminRegister />} />
      </Routes>
     {/* Only show the footer if the route does not start with /admin or /cause */}
{!location.pathname.startsWith("/admin") && !location.pathname.startsWith("/cause/") && <Footer />}

    </>
  );
}
export default App;


